interface MarketplaceSVGProps {
  style: React.CSSProperties;
  color: string;
}

const MarketplaceSVG = ({ color, style }: MarketplaceSVGProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="58"
    height="50"
    viewBox="0 0 58 50"
    fill="none"
  >
    <g clipPath="url(#clip0_535_18813)">
      <path
        d="M39.6665 22.8822C39.6665 24.1154 40.6599 25.1088 41.893 25.1088C43.1262 25.1088 44.1196 24.1154 44.1196 22.8822C44.1196 21.6491 43.2061 21.0782 41.893 20.6557C40.7284 20.2789 39.6665 19.6623 39.6665 18.4292C39.6665 17.196 40.6599 16.2026 41.893 16.2026C43.1262 16.2026 44.1196 17.196 44.1196 18.4292"
        stroke={color}
        strokeWidth="1.27883"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M41.9048 14.958V16.214"
        stroke={color}
        strokeWidth="1.27883"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M41.9048 25.1089V26.3763"
        stroke={color}
        strokeWidth="1.27883"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M41.6188 42.9324H4.1902C2.22628 42.9324 0.63916 41.3453 0.63916 39.3814V3.41425C0.63916 1.88422 1.88374 0.639648 3.41377 0.639648H49.5887C51.1187 0.639648 52.3633 1.88422 52.3633 3.41425V34.9283"
        stroke={color}
        strokeWidth="1.27883"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5928 6.2234C7.5928 5.94937 7.37585 5.73242 7.10182 5.73242C6.82778 5.73242 6.61084 5.94937 6.61084 6.2234C6.61084 6.49744 6.82778 6.71438 7.10182 6.71438C7.37585 6.71438 7.5928 6.49744 7.5928 6.2234Z"
        stroke={color}
        strokeWidth="1.27883"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.1421 6.2234C13.1421 5.94937 12.9252 5.73242 12.6511 5.73242C12.3771 5.73242 12.1602 5.94937 12.1602 6.2234C12.1602 6.49744 12.3771 6.71438 12.6511 6.71438C12.9252 6.71438 13.1421 6.49744 13.1421 6.2234Z"
        stroke={color}
        strokeWidth="1.27883"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.6914 6.2234C18.6914 5.94937 18.4745 5.73242 18.2005 5.73242C17.9264 5.73242 17.7095 5.94937 17.7095 6.2234C17.7095 6.49744 17.9264 6.71438 18.2005 6.71438C18.4745 6.71438 18.6914 6.49744 18.6914 6.2234Z"
        stroke={color}
        strokeWidth="1.27883"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M53.1512 42.0534L56.588 38.6165L41.9043 34.6772L45.8321 49.361L49.2804 45.9241"
        stroke={color}
        strokeWidth="1.27883"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M52.1235 44.8965L56.4168 49.1897"
        stroke={color}
        strokeWidth="1.27883"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.0103 16.4883L35.3732 21.8091L26.0103 27.2099L16.6475 21.8091L26.0103 16.4883Z"
        stroke={color}
        strokeWidth="1.27883"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.0103 38.0228L16.6475 32.6221V21.8091"
        stroke={color}
        strokeWidth="1.27883"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M26.0107 38.0228L35.3736 32.6221V21.8091"
        stroke={color}
        strokeWidth="1.27883"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M26.0107 27.21V34.392"
        stroke={color}
        strokeWidth="1.27883"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M0.63916 11.7041H52.3747"
        stroke={color}
        strokeWidth="1.27883"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_535_18813">
        <rect width="57.2277" height="50" fill={color} />
      </clipPath>
    </defs>
  </svg>
);

export default MarketplaceSVG;
